import { SideBarActionsPreview } from '../../../../common/components/side-bar/SideBarActionsPreview'
import { useSelector } from 'react-redux'
import { userSlice } from '@wellesley/user'
import { getUserImage } from 'helpers/getUserImage'
import { AppsLink, getRoute } from '@wellesley/router'
import { defaultCover } from 'components/ProfileCover'
import { authSlice } from '@wellesley/auth'
import logo from './logo.png'
import cover from './cover.png'
import { SideBarPreview } from '../../../../common/components/side-bar/SideBarActionsPreview/SideBarPreview'
import { Button } from '@wellesley/ui'
import { PersonalActions } from '../PersonalActions'
import { DropdownTitle } from '../../../../common/components/side-bar/SideBarActionsPreview/actions/DropdownTitle'
import { useState } from 'react'

export const GuestPreview = () => {
  return (
    <div>
      <SideBarPreview
        cover={cover}
        avatar={logo}
        title="Welcome to Wellesley!"
      />
      <div className="flex flex-col gap-xxs px-m pb-s">
        <AppsLink to={getRoute('/signin')}>
          <Button variant="primary" size="m" className="w-full">
            Log in
          </Button>
        </AppsLink>
        <AppsLink to={getRoute('/signup')}>
          <Button variant="secondary" size="m" className="w-full">
            Sign up
          </Button>
        </AppsLink>
      </div>
    </div>
  )
}
export const UserPreview = () => {
  const currentUser = useSelector(userSlice.selectors.selectCurrentUser)
  const [isOpen, setIsOpen] = useState(false)
  return (
    <SideBarActionsPreview
      cover={
        getUserImage({ user: currentUser, type: 'header' }) || defaultCover
      }
      avatar={getUserImage({ user: currentUser })}
      title={currentUser?.displayName}
    >
      <PersonalActions
        align="start"
        alignOffset={16}
        isPortal={false}
        onOpenChange={setIsOpen}
        trigger={
          <DropdownTitle
            title={currentUser?.displayName || ''}
            isOpen={isOpen}
          />
        }
        triggerClass="min-w-m w-full flex size-full"
      />
    </SideBarActionsPreview>
  )
}

export const PersonalSpacePreview = () => {
  const isLoggedIn = useSelector(authSlice.selectors.selectIsAuthenticated)
  return isLoggedIn ? <UserPreview /> : <GuestPreview />
}
